import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import AOS from "aos";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isNavOpen, setIsNavOpen] = useState(false); // State for navbar toggle

  useEffect(() => {
    AOS.init({ duration: 30000, once: true, offset: 100 });

    // Simulate loading for 1 second, then hide preloader
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const scrollBtn = document.querySelector(".scroll-top");
    const handleScroll = () =>
      (scrollBtn.style.display = window.scrollY > 300 ? "block" : "none");
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const sliderImages = [
    "images/assets/screen_1.png",
    "images/assets/screen_2.png",
    "images/assets/screen_3.png",
    "images/assets/screen_4.png",
    "images/assets/screen_5.png",
    "images/assets/screen_6.png",
    "images/assets/screen_7.png",
    "images/assets/screen_8.png",
    "images/assets/screen_9.png",
    "images/assets/screen_10.png",
    "images/assets/screen_11.png",
    "images/assets/screen_12.png",
    "images/assets/screen_13.png",
    "images/assets/screen_14.png",
    "images/assets/screen_15.png",
    "images/assets/screen_16.png",
    "images/assets/screen_17.png",
    "images/assets/screen_18.png",
    "images/assets/screen_19.png",
    "images/assets/screen_20.png",
    "images/assets/screen_21.png",
    "images/assets/screen_22.png",
    "images/assets/screen_23.png",
    "images/assets/screen_24.png",
    "images/assets/screen_25.png",
    "images/assets/screen_26.png",
    "images/assets/screen_27.png",
    "images/assets/screen_28.png",
    "images/assets/screen_29.png",
    "images/assets/screen_30.png",
    "images/assets/screen_31.png",
    "images/assets/screen_32.png",
    "images/assets/screen_33.png",
    "images/assets/screen_34.png",
    "images/assets/screen_35.png",
    "images/assets/screen_36.png",
    "images/assets/screen_37.png",
    "images/assets/screen_38.png",
    "images/assets/screen_39.png",
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  const EnhancedImage = ({ src, alt, className = "", ...props }) => {
    const fallback = "images/placeholder.png";
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        loading="lazy"
        onError={(e) => (e.target.src = fallback)}
        {...props}
      />
    );
  };

  const services = [
    {
      title: "Contactez-nous",
      img: "images/assets/contactez-nous.png",
      desc: "Remplissez notre formulaire ou appelez-nous pour nous parler de votre besoin.",
    },
    {
      title: "Recevez votre devis personnalisé",
      img: "images/assets/obtenez-votre-devis-personnalisé.png",
      desc: "Nous analysons votre demande et vous envoyons un devis clair et détaillé.",
    },
    {
      title: "Donnez-nous le feu vert",
      img: "images/assets/donnez-nous-le-feu-vert.png",
      desc: "Nous analysons votre demande et vous envoyons un devis clair et détaillé.",
    },
  ];

  const faqs = [
    {
      question: "Est-ce que vous développez n'importe quel type de logiciel ?",
      answer:
        "Oui, nous créons des logiciels personnalisés selon vos besoins : applications web, mobiles, CRM, ERP, plateformes de réservation...",
    },
    {
      question:
        "Est-ce que vous faites aussi de l'intégration avec nos outils existants ?",
      answer:
        "Absolument. Nous pouvons connecter votre futur logiciel avec vos systèmes actuels (API, ERP, CRM...).",
    },
    {
      question: "Combien coûte un logiciel sur mesure ?",
      answer:
        "Le tarif dépend de la complexité du projet. Après discussion, nous fournissons un devis clair et détaillé.",
    },
    {
      question: "Comment se passe la collaboration avec vous ?",
      answer:
        "Nous commençons par une analyse de vos besoins, puis nous créons un cahier des charges, développons le logiciel, et faisons des tests avec vous. Vous êtes impliqué à chaque étape.",
    },
    {
      question: "Et après la livraison ? Est-ce que vous assurez un suivi ?",
      answer:
        "Oui. Nous proposons un accompagnement post-livraison : corrections, mises à jour, évolutions futures ou maintenance selon vos besoins.",
    },
    {
      question: "Le logiciel fonctionnera-t-il sur tous les appareils ?",
      answer:
        "Oui, si c'est nécessaire. Nous pouvons développer des applications web responsives, mobiles (iOS/Android), ou des logiciels de bureau selon vos usages.",
    },
    {
      question: "Est-ce que vous utilisez des technologies récentes ?",
      answer:
        "Nous utilisons des technologies modernes, fiables et maintenables pour garantir performance, sécurité et évolutivité. DVELGE GROUP : « Contactez-nous dès aujourd'hui pour découvrir comment nos solutions peuvent répondre à vos défis spécifiques et propulser votre entreprise vers l'avenir. »",
    },
  ];

  return (
    <>
      {isLoading && (
        <div id="preloader">
          <div id="ctn-preloader" className="ctn-preloader">
            <div className="animation-preloader">
              <div className="spinner"></div>
              <div className="txt-loading">
                {"DVELGE LOGICIEL".split().map((letter, i) => (
                  <span
                    key={i}
                    data-text-preloader={letter}
                    className="letters-loading"
                  >
                    {letter}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="main-page-wrapper p0">
        {/* Header */}
        <div className="theme-main-menu sticky-menu theme-menu-four bg-none">
          <div className="d-flex align-items-center justify-content-between">
            <div className="logo">
              <Link to="/">
                <EnhancedImage src="images/logo/logo.png" alt="Logo" />
              </Link>
            </div>
            <nav id="mega-menu-holder" className="navbar navbar-expand-lg">
              <div className="nav-container">
                {/* Toggler button with state toggle */}
                <button
                  className={`navbar-toggler ${isNavOpen ? "open" : ""}`}
                  onClick={() => setIsNavOpen(!isNavOpen)}
                  aria-expanded={isNavOpen}
                >
                  <span></span>
                </button>
                {/* Collapsible menu - show class controlled by state */}
                <div
                  className={`navbar-collapse collapse ${isNavOpen ? "show" : ""}`}
                  id="navbarSupportedContent"
                >
                  <div className="d-lg-flex align-items-center">
                    <ul className="navbar-nav">
                      <li className="nav-item dropdown position-static active">
                        <Link className="nav-link" to="/">
                          Accueil
                        </Link>
                      </li>
                    </ul>
                    <ul className="right-button-group d-flex align-items-center justify-content-center">
                      <li>
                        <Link to="/demande" className="theme-btn-five">
                          Faites-nous part de vos besoins dès aujourd'hui
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>

        {/* Hero */}
        <div className="hero-banner-four">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 order-lg-last">
                <div className="illustration-holder">
                  <EnhancedImage
                    src="images/assets/hero.png"
                    alt=""
                    className="illustration"
                  />
                </div>
                <p className="review-text">
                  Des <span>Clients Satisfaits </span>Partout en Guinée.
                </p>
              </div>

              <div className="col-lg-6 order-lg-first">
                <div className="text-wrapper">
                  <h1>
                    <span>Développement D'applications </span> Sur Mesure
                  </h1>
                  <p className="sub-text">
                    Nous améliorons l'efficacité opérationnelle en développant
                    des logiciels sur mesure pour automatiser tâches
                    répétitives.
                  </p>
                  <Link to="/demande" className="theme-btn-five">
                    Commençons
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="fancy-feature-eight mt-160 md-mt-100">
          <div className="container">
            <div className="bg-wrapper">
              <div className="row justify-content-center">
                <div
                  className="col-lg-4 col-md-6 aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                >
                  <div className="block-style-thirteen">
                    <div className="icon">
                      <img src="images/icon/ussd.jpg" alt="" />
                    </div>
                    <div className="title font-rubik">USSD</div>
                    <p>
                      transformez l’expérience utilisateur avec des interactions
                      simplifiées et un accès instantané, même dans les zones à
                      faible connectivité, garantissant une accessibilité
                      continue pour vos clients.
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6 aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="100"
                >
                  <div className="block-style-thirteen style-border">
                    <div className="icon">
                      <img src="images/icon/mobile.jpg" alt="" />
                    </div>
                    <div className="title font-rubik">Mobiles</div>
                    <p>
                      créez des expériences mobiles immersives et intuitives sur
                      Android et iOS, parfaitement adaptées aux besoins
                      spécifiques de vos clients, pour fidéliser et engager
                      votre audience
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6 aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="200"
                >
                  <div className="block-style-thirteen">
                    <div className="icon">
                      <img src="images/icon/bureau.jpg" alt="" />
                    </div>
                    <div className="title font-rubik">Bureau</div>
                    <p>
                      proposez des solutions de bureau puissantes et fiables,
                      offrant des fonctionnalités hors ligne pour assurer une
                      productivité maximale, même sans connexion
                      internet(hors-ligne), et une gestion fluide de vos
                      processus.
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6 aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="200"
                >
                  <div className="block-style-thirteen">
                    <div className="icon">
                      <img src="images/icon/web.jpg" alt="" />
                    </div>
                    <div className="title font-rubik">Applications Web</div>
                    <p>
                      offrez des applications accessibles sur tous les
                      appareils, optimisant la gestion de vos processus métiers
                      avec une expérience fluide et responsive.
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6 aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="200"
                >
                  <div className="block-style-thirteen">
                    <div className="icon">
                      <img src="images/icon/api.jpg" alt="" />
                    </div>
                    <div className="title font-rubik">
                      Intégration d’API et services Web
                    </div>
                    <p>
                      connectez vos applications à des passerelles de paiement,
                      systèmes CRM, et autres plateformes tierces pour une
                      expérience fluide et cohérente .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="fancy-text-block-nineteen mt-250 mb-200 md-mt-150 md-mb-150">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-lg-6 aos-init aos-animate"
                data-aos="fade-right"
                data-aos-duration="1200"
              >
                <img src="images/media/partner.jpg" alt="" className="m-auto" />
              </div>
              <div
                className="col-lg-6 aos-init aos-animate"
                data-aos="fade-left"
                data-aos-duration="1200"
              >
                <div className="text-wrapper">
                  <div className="title-style-five">
                    <h2>
                      <span>Votre Partenaire Technologique pour </span> des
                      Solutions sur Mesure.
                    </h2>
                  </div>
                  <p className="font-rubik">
                    Nos solutions personnalisées sont conçues pour répondre à
                    vos besoins commerciaux uniques, en combinant des
                    technologies de pointe avec des expériences utilisateur
                    fluides des architectures évolutives.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Services */}
        <div className="fancy-feature-nine">
          <div className="container">
            <div className="title-style-five text-center mb-60 md-mb-30">
              <h6>COMMENCEZ EN QUELQUES MINUTES</h6>
              <h2>
                <span>Votre projet en 3 étapes simples.</span>
              </h2>
            </div>
            <div className="row justify-content-center">
              {services.map((s, i) => (
                <div
                  key={i}
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay={i * 100}
                >
                  <div className="block-style-fourteen">
                    <div className="illustration">
                      <EnhancedImage src={s.img} alt={s.title} />
                    </div>
                    <div className="title">{s.title}</div>
                    <p className="font-rubik">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="fancy-text-block-six mt-250 md-mt-200">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-lg-6 aos-init"
                data-aos="fade-right"
                data-aos-duration="1200"
              >
                <div className="title-style-five mb-35">
                  <h6>Pourquoi nous choisir ?</h6>
                  <h2>
                    <span>Pourquoi</span> nous choisir ?
                  </h2>
                </div>

                <div id="accordion" className="accordion-style-two pr-5">
                  <div className="card">
                    <div className="card-header " id="headingOne">
                      <h5 className="mb-0">
                        <button className="btn btn-link">
                          Expertise technique éprouvée
                        </button>
                      </h5>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h5 className="mb-0">
                        <button className="btn btn-link">
                          Équipe à l’écoute et réactive
                        </button>
                      </h5>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingThree">
                      <h5 className="mb-0">
                        <button className="btn btn-link">
                          Solutions évolutives
                        </button>
                      </h5>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingThree">
                      <h5 className="mb-0">
                        <button className="btn btn-link">
                          Processus agile et collaboratif
                        </button>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-6 col-md-8 m-auto aos-init"
                data-aos="fade-left"
                data-aos-duration="1200"
              >
                <div className="illustration-holder d-flex justify-content-end md-mt-50">
                  <img src="images/media/pourquoi_nous_choisir.jpg" alt="" />
                  <img
                    src="images/shape/113.svg"
                    alt=""
                    className="shapes shape-one"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* App Slider */}
        <div className="app-screen-preview-two mt-200 md-mt-130">
          <div className="container">
            <div className="title-style-eleven text-center mb-120 md-mb-70">
              <h2>App Screenshot</h2>
            </div>
          </div>
          <Slider {...sliderSettings}>
            {sliderImages.map((img, i) => (
              <div key={i} className="item">
                <div className="img-holder">
                  <EnhancedImage src={img} alt={`Screenshot ${i + 1}`} />
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* FAQ */}
        <div className="faq-section-four">
          <div className="container">
            <div className="title-style-five text-center mb-80 md-mb-60">
              <h6>Questions fréquentes</h6>
              <h2>
                <span>Question & Réponse</span>
              </h2>
            </div>
            <div className="row">
              <div className="col-xl-9 col-lg-10 m-auto">
                <div id="accordionThree" className="accordion-style-four">
                  {faqs.map((f, i) => (
                    <div key={i} className="card">
                      <div className="card-header" id={`heading${i}`}>
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${i}`}
                            aria-expanded={i === 0 ? "true" : "false"}
                            aria-controls={`collapse${i}`}
                          >
                            {f.question}
                          </button>
                        </h5>
                      </div>
                      <div
                        id={`collapse${i}`}
                        className={`collapse ${i === 0 ? "show" : ""}`}
                        aria-labelledby={`heading${i}`}
                        data-bs-parent="#accordionThree"
                      >
                        <div className="card-body">
                          <p>{f.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="theme-footer-four">
          <div className="top-footer">
            <div className="container">
              <div className="row justify-content-end">
                <div className="col-xl-4 col-lg-3 col-12 footer-about-widget">
                  <div className="logo">
                    <a href="#">
                      <EnhancedImage src="images/logo/logo.png" alt="Logo" />
                    </a>
                  </div>
                  <ul className="font-rubik mt-10">
                    <li>
                      <Link to="mailto:info@dvelgegroup.com">
                        info@dvelgegroup.com
                      </Link>
                    </li>
                    <li>
                      <Link to="tel:+224623300992">+224 623300992</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6 col-md-6 footer-list">
                  <h5 className="footer-title font-slab">Liens</h5>
                  <ul>
                    <li>
                      <Link to="https://logiciel.dvelgegroup.com">
                        Demande de Logiciel
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.dvelgegroup.com">
                        Site Principal
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="bottom-footer-content">
              <p>© 2026 logiciel.dvelgegroup.com. Tous droits réservés.</p>
            </div>
          </div>
        </footer>

        {/* Scroll Top */}
        <button
          className="scroll-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <i className="fa fa-angle-up" aria-hidden="true"></i>
        </button>
      </div>
    </>
  );
};

export default Home;
